import { Failure } from '../core/failure';

export enum StorageFailureTypes {
  thisKeyIsNotDefinedYet,
  cacheExpired,
}

export class StorageFailure extends Failure<StorageFailureTypes, void> {
  private constructor(errorMessage: string, errorType: StorageFailureTypes) {
    super(errorMessage, errorType, undefined);
  }

  public static thisKeyIsNotDefinedYet() {
    return new StorageFailure(
      'Ainda não foi setado um valor para a chave',
      StorageFailureTypes.thisKeyIsNotDefinedYet
    );
  }

  public static cacheExpired() {
    return new StorageFailure(
      'Esse valor já foi setado mas expirou',
      StorageFailureTypes.cacheExpired
    );
  }
}
